/**
 * Full-width product grid for the products / category listing pages (converted
 * from the `.product-cards-wrapper` section of products.html). Reuses the
 * shared ProductCard for every item; the empty state mirrors the Webflow
 * `.w-dyn-empty` block. The card fade-up reveal and image crossfade are wired
 * globally in SiteAnimations.
 */
import type { FC } from 'react'
import type { Product } from '@/types'

import { ProductCard } from '@/components/common/product-card'

interface ProductListProps {
    products: Product[]
}

export const ProductList: FC<ProductListProps> = ({ products }) => {
    return (
        <div className='section'>
            <div className='container'>
                <div className='product-cards-wrapper w-dyn-list'>
                    {products.length > 0 ? (
                        <div role='list' className='product-grid w-dyn-items'>
                            {products.map((product) => (
                                <ProductCard key={product.id} product={product} />
                            ))}
                        </div>
                    ) : (
                        <div className='w-dyn-empty'>
                            <div>No items found.</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
